import { EditableEntity, type IEditableEntity, type IPropEventBroker, type IReadablePropEventBroker } from '@zdrbm/zdr-native-tools';

export enum FeedbackType {
    Positive = 'positive',
    Negative = 'negative',
    Unset = 'unset',
}

export interface IFeedback extends IEditableEntity {
  type: IReadablePropEventBroker<FeedbackType>;
  content: IReadablePropEventBroker<string>;

  setType(feedbackType: FeedbackType): void;
  setContent(content: string): void;
}

export class Feedback extends EditableEntity<keyof IFeedback> implements IFeedback {

  type: IPropEventBroker<FeedbackType>;
  content: IPropEventBroker<string>;

  constructor(
    feedbackType: FeedbackType,
    content: string,
  ) {
    super(undefined);
    this.type = this.createPropEventBroker<FeedbackType>('type', feedbackType);
    this.content = this.createPropEventBroker<string>('content', content);
  }

  setType(feedbackType: FeedbackType): void {
    this.type.set(feedbackType);
  }

  setContent(content: string): void {
    this.content.set(content);
  }

  getEntityName(): string {
    return 'Feedback';
  }
}